type Color = "emerald"|"amber"|"red"|"blue"|"slate"|"violet"|"pink";

const map: Record<Color, string> = {
  emerald: "bg-emerald-50  text-emerald-700 border-emerald-200",
  amber:   "bg-amber-50   text-amber-700   border-amber-300",
  red:     "bg-red-50     text-red-700     border-red-300",
  blue:    "bg-blue-50    text-blue-700    border-blue-300",
  slate:   "bg-slate-100  text-slate-600   border-slate-300",
  violet:  "bg-violet-50  text-violet-700  border-violet-300",
  pink:    "bg-pink-50    text-pink-700    border-pink-300",
};

export default function Badge({ label, color="slate" }: { label: string; color?: Color }) {
  return (
    <span className={`inline-flex items-center text-[11px] font-medium px-2 py-0.5 rounded-full border whitespace-nowrap ${map[color]}`}>
      {label}
    </span>
  );
}
